import { render, staticRenderFns } from "./ReviewQuestionElectionItem.vue?vue&type=template&id=7ad92c48"
import script from "./ReviewQuestionElectionItem.vue?vue&type=script&lang=js"
export * from "./ReviewQuestionElectionItem.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports